/* CUBE STORE - carrello

   1) tasto per passare al carrello a tutta pagina dalla barra laterale;
   2) riga "Taglia M - Codice 117400" sotto il nome dell'articolo, e sotto
      di lei la data di arrivo se la taglia e' prenotata;
   3) riepilogo delle scelte di pagamento fatte in scheda prodotto;
   4) riepilogo con articoli, prenotazione, totale e saldo;
   5) la casella delle note per il negozio, sotto lo sconto.

   I totali del riepilogo NON sono calcolati qui: arrivano gia' formattati
   dall'isola dati, dove il totale e' cart.total_price, cioe' quello
   che incassera' davvero il checkout. Se non c'e' nessun acconto attivo,
   hasDeposit e' false e le righe del saldo non vengono mostrate: meglio un
   riepilogo piu' povero che un numero che il checkout non conferma.

   Il tema ridisegna il contenuto a ogni modifica del carrello, quindi tutto
   va rimesso: ci pensa l'osservatore.

   ==========================================================
   L'ISOLA DATI INVECCHIA, E VA RILETTA DAL SERVER
   ==========================================================

   L'isola - lo <script type="application/json"> che monta
   snippets/cube-preorder-data.liquid - vive nel LAYOUT, cioe' fuori da
   ogni sezione. Quando il cliente cambia la quantita' o aggiunge un
   articolo, Shopify ridisegna soltanto la sezione del carrello: il
   layout non viene rigenerato, e l'isola resta ferma ai numeri del
   caricamento.

   Il guasto che ne veniva era brutto proprio perche' silenzioso: la
   riga dell'articolo mostrava 6.198,00, il pallino del carrello
   segnava 2, e il riepilogo a destra continuava a dire "Articoli (1)
   3.099" con lo stesso importo sul pulsante di pagamento. Nessun
   errore in console. Si sistemava solo ricaricando la pagina.

   PERCHE' NON SI RICALCOLA QUI. Servirebbero i metafield di variante -
   quali righe sono in prenotazione - e i metafield di prodotto: roba
   che vive in Liquid e che il carrello in JSON non espone. Rifarne una
   copia a mano qui dentro vorrebbe dire tenere allineate due verita'
   sul denaro, ed e' esattamente il tipo di doppione che questo file
   dice di non voler fare due righe piu' su. Si rilegge l'originale.

   IL SEGNALE E' cart:update, NON L'OSSERVATORE, e qui stava la meta'
   nascosta del guasto. Cambiando la quantita' il tema riscrive il
   TESTO dei prezzi e il valore della casella: modifiche di solo testo,
   che non sono childList. L'osservatore in fondo al file guarda
   childList e basta - misurato: zero chiamate a run() dopo un piu' o
   un meno. Non e' che il riepilogo si ridisegnasse sbagliato: non si
   ridisegnava affatto. Il tema pero' annuncia ogni modifica con
   l'evento cart:update sul documento, ed e' li' che ci si attacca.
   L'osservatore resta perche' serve ad altro - il cassetto laterale
   che nasce dopo, il tasto da rimettere.

   COME CI SI ACCORGE CHE E' VECCHIA, SENZA CHIEDERLO ALLA RETE. Oltre
   all'evento c'e' una rete di sicurezza: si confronta l'elenco "chiave
   riga per quantita'" preso dall'isola con lo stesso elenco letto
   dalla pagina. Copre le modifiche che arrivano da fuori - un'altra
   scheda del browser, un'altra app - dove nessun cart:update passa di
   qui. Finche' i due coincidono non si tocca niente: nel caso normale
   non parte nessuna richiesta.

   UNA SOLA RICHIESTA PER STATO, E IL MOTIVO NON E' IL RISPARMIO.
   ultimaChiesta ricorda per quale impronta di pagina si e' gia'
   chiesto. Senza, un'impronta che per qualsiasi ragione non tornasse
   mai a coincidere - una quantita' tagliata dalla giacenza colta a
   meta' strada, una risposta che non arriva - farebbe girare
   osservatore e richiesta all'infinito, uno dietro l'altro. Con
   quella riga il peggio che puo' capitare e' un riepilogo che resta
   indietro: fastidioso, non un incendio.

   SI DISEGNA PRIMA E SI CORREGGE DOPO. Il riepilogo viene rifatto
   subito con i dati che ci sono, anche se vecchi, e ridisegnato quando
   arrivano quelli buoni. Aspettare la rete per mostrarlo vorrebbe dire
   un buco al posto dei totali a ogni modifica. */
(function () {
  var FULL_LABEL = 'Visualizza carrello';
  var TITOLO_SCELTE = 'Pagamento scelto';

  var ICON =
    '<svg viewBox="0 0 24 24" aria-hidden="true">' +
    '<path d="M15 3h6v6M21 3l-7 7M9 21H3v-6M3 21l7-7"/>' +
    '</svg>';

  var NOTE =
    'Il saldo non viene addebitato automaticamente. Ti contattiamo noi quando ' +
    'la bici arriva in sede e concordiamo il pagamento del restante 90%.';

  function data() {
    var node = document.getElementById('cube-preorder-data');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      return null;
    }
  }

  function cartUrl() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root + 'cart'
      : '/cart';
  }

  /* ---------- tasto "visualizza carrello" nella barra laterale ---------- */

  function placeButton() {
    var drawer = document.querySelector('.cart-drawer__dialog');
    if (!drawer) return;

    var ctas = drawer.querySelector('.cart__ctas');
    if (!ctas || ctas.querySelector('.cube-cart-full')) return;

    var link = document.createElement('a');
    link.className = 'cube-cart-full';
    link.href = cartUrl();
    link.innerHTML = ICON + '<span>' + FULL_LABEL + '</span>';

    ctas.insertBefore(link, ctas.firstChild);
  }

  /* ---------- riga taglia + codice, e scelte di pagamento ---------- */

  /* Le scelte arrivano gia' filtrate dall'isola dati: niente chiavi di
     servizio dell'app, niente campi lasciati vuoti. Qui si stampano e
     basta. Il testo non passa mai da innerHTML: i valori li scrive il
     cliente, e un nome di campo con dentro un segno di minore
     spezzerebbe la pagina. */
  function scelte(row, line) {
    if (!line.props || !line.props.length) return;

    var wrap = row.querySelector('.cart-items__variants-wrapper');
    if (!wrap || wrap.querySelector('.cube-scelte')) return;

    var box = document.createElement('div');
    box.className = 'cube-scelte';

    var titolo = document.createElement('p');
    titolo.className = 'cube-scelte__titolo';
    titolo.textContent = TITOLO_SCELTE;
    box.appendChild(titolo);

    line.props.forEach(function (p) {
      var riga = document.createElement('div');
      riga.className = 'cube-scelte__riga';

      var nome = document.createElement('span');
      nome.className = 'cube-scelte__nome';
      nome.textContent = p.nome + ':';

      var valore = document.createElement('span');
      valore.className = 'cube-scelte__valore';
      valore.textContent = p.valore;

      riga.appendChild(nome);
      riga.appendChild(valore);
      box.appendChild(riga);
    });

    wrap.appendChild(box);
  }

  function placeMeta(payload) {
    payload.lines.forEach(function (line) {
      document.querySelectorAll('tr[data-key="' + line.key + '"]').forEach(function (row) {
        scelte(row, line);

        if (row.dataset.cubeMeta === '1') return;
        row.dataset.cubeMeta = '1';

        var wrap = row.querySelector('.cart-items__variants-wrapper');
        if (!wrap) return;

        var bits = [];
        if (line.size) bits.push('Taglia ' + line.size);
        if (line.code) bits.push('Codice ' + line.code);

        var ancora = wrap.firstChild;

        if (bits.length) {
          var meta = document.createElement('p');
          meta.className = 'cube-cart-meta';
          meta.textContent = bits.join(' · ');
          wrap.insertBefore(meta, ancora);
          ancora = meta.nextSibling;
        }

        /* LA DATA DI ARRIVO, chiesta da Alberto il 18 agosto 2026.

           Il dato non e' nuovo e non si va a cercare da nessuna parte:
           l'isola lo scrive gia' per ogni riga ("preorder" e "arrival"),
           leggendolo dal metafield di variante custom.expected_arrival_date.
           Fin qui non veniva semplicemente stampato.

           Sta su una riga sua e non in coda a "Taglia · Codice" perche' su
           una prenotazione e' l'informazione che conta di piu': dice quando
           arriva la bici. Infilata come terza voce di un elenco grigio si
           legge come un dettaglio di magazzino.

           Si mostra SOLO se la riga e' davvero in prenotazione: su una bici
           in pronta consegna una data futura sarebbe una promessa sbagliata. */
        if (line.preorder && line.arrival) {
          var arrivo = document.createElement('p');
          arrivo.className = 'cube-cart-arrivo';
          arrivo.textContent = 'Arrivo previsto ' + line.arrival;
          wrap.insertBefore(arrivo, ancora);
        }

        /* il prezzo unitario dentro i dettagli e' identico al totale di riga
           quando la quantita' e' 1: in quel caso e' solo un doppione */
        var unit = row.querySelector('.cart-items__unit-price-wrapper');
        if (unit && line.quantity <= 1) unit.hidden = true;
      });
    });
  }

  /* ---------- riepilogo ---------- */

  function row(label, value, variant) {
    return (
      '<div class="cube-sum__row' + (variant ? ' cube-sum__row--' + variant : '') + '">' +
      '<span>' + label + '</span><b>' + value + '</b>' +
      '</div>'
    );
  }

  function placeSummary(payload) {
    var cart = payload.cart;
    if (!cart) return;

    document.querySelectorAll('.cart-summary__inner').forEach(function (inner) {
      var old = inner.querySelector('.cube-sum');
      if (old) old.remove();

      var block = document.createElement('div');
      block.className = 'cube-sum';

      var html =
        '<p class="cube-sum__title">Riepilogo</p>' +
        row('Articoli (' + cart.itemCount + ')', cart.full);

      if (cart.hasPreorder) {
        html += row('di cui in prenotazione', cart.preorderFull, 'muted');
      }

      /* Non si promette piu' "Gratuita": qui la spedizione non si
         conosce ancora - dipende dall'indirizzo, che il cliente non ha
         nemmeno scritto - e prometterla gratis a tutti voleva dire
         smentirsi da soli due schermate dopo, con il costo che compare
         al checkout. Si dice quello che si sa: che il conto lo fa il
         checkout. */
      html += row('Spedizione', '<span class="cube-sum__calc">Calcolata al check-out</span>');

      html +=
        '<div class="cube-sum__divider"></div>' +
        '<div class="cube-sum__now">' +
          '<span>Totale</span><strong>' + cart.payNow + '</strong>' +
        '</div>';

      if (cart.hasDeposit) {
        if (cart.hasInStock) {
          html += '<p class="cube-sum__breakdown">acconto ' + cart.deposit +
                  ' + articoli disponibili ' + cart.inStock + '</p>';
        }
        html += '<div class="cube-sum__balance"><span>Saldo alla disponibilità</span><b>' +
                cart.balance + '</b></div>';
      }

      block.innerHTML = html;
      inner.insertBefore(block, inner.firstChild);

      /* nota sotto i pulsanti, solo quando c'e' davvero un saldo da versare */
      var ctas = inner.querySelector('.cart__ctas');
      if (ctas) {
        var note = ctas.querySelector('.cube-sum__note');
        if (cart.hasDeposit) {
          if (!note) {
            note = document.createElement('p');
            note.className = 'cube-sum__note';
            note.textContent = NOTE;
            ctas.appendChild(note);
          }
        } else if (note) {
          note.remove();
        }
      }

      /* Il tema scrive solo "Check-out", che detto cosi' e' un'etichetta
         piu' che un invito. Qui diventa "Conferma ordine".

         C'era anche l'importo in coda - "Procedi al pagamento · €6.999" -
         tolto su richiesta di Marco l'11 agosto 2026: la cifra e' gia'
         scritta due righe piu' su, grande e in blu, e ripeterla sul
         pulsante la faceva sembrare un secondo totale invece dello
         stesso. Per rimetterla basta concatenare cart.payNow. */
      var label = inner.querySelector('.cart__checkout-button .button-text');
      if (label) label.textContent = 'Conferma ordine';

      placeNote(inner);
    });
  }

  /* ---------- le note per il negozio ---------- */

  /* IL TEMA CE L'HA GIA', E NON LA USIAMO. La casella note nativa vive
     in snippets/cart-summary.liquid ma e' spenta da settings.show_cart_note,
     un booleano dentro config/settings_data.json - cioe' il file che
     contiene TUTTA la configurazione del tema, colori e caratteri
     compresi. Riscriverlo per cambiare una parola era il modo piu' caro
     e piu' rischioso di ottenere questa casella. In piu' il tema la
     disegna SOPRA lo sconto, mentre qui la si vuole sotto.

     IL TESTO VIAGGIA IN DUE MODI, E SERVONO TUTTI E DUE:
       - name="note" con form="cart-form" lo manda insieme al checkout,
         ed e' cosi' che finisce sull'ordine;
       - il salvataggio ritardato su /cart/update.js lo tiene anche se il
         cliente non conclude subito, e glielo fa ritrovare al ritorno.
     Con il solo primo, chi scrive e poi va a farsi un giro perde tutto;
     con il solo secondo, una nota scritta e mandata entro il mezzo
     secondo di attesa non arriverebbe.

     IL VALORE VIVE ANCHE IN MEMORIA. Il tema ridisegna il riepilogo a
     ogni modifica del carrello: senza ultimaNota, chi scrive una nota e
     poi cambia la quantita' se la vedrebbe sparire sotto le dita. */

  var ultimaNota = null;
  var salvaNota = null;

  function leggiNota() {
    if (ultimaNota !== null) return Promise.resolve(ultimaNota);

    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        ultimaNota = c.note || '';
        return ultimaNota;
      })
      .catch(function () { return ''; });
  }

  function placeNote(inner) {
    var azioni = inner.querySelector('.cart-actions');
    if (!azioni) return;

    var box = inner.querySelector('.cube-nota');

    if (!box) {
      box = document.createElement('details');
      box.className = 'cube-nota';

      var titolo = document.createElement('summary');
      titolo.className = 'cube-nota__titolo';
      titolo.innerHTML = '<span>Note</span><span class="cube-nota__segno" aria-hidden="true"></span>';

      var corpo = document.createElement('div');
      corpo.className = 'cube-nota__corpo';

      var campo = document.createElement('textarea');
      campo.className = 'cube-nota__campo';
      campo.name = 'note';
      campo.rows = 3;
      campo.setAttribute('form', 'cart-form');
      campo.setAttribute('aria-label', 'Note per il negozio');
      campo.placeholder = 'Hai qualcosa da segnalarci su questo ordine? Scrivilo qui.';

      campo.addEventListener('input', function () {
        ultimaNota = campo.value;
        clearTimeout(salvaNota);
        salvaNota = setTimeout(function () {
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ note: ultimaNota })
          }).catch(function () {});
        }, 500);
      });

      corpo.appendChild(campo);
      box.appendChild(titolo);
      box.appendChild(corpo);

      /* sotto lo sconto, sopra i pulsanti: e' il posto chiesto, ed e'
         anche l'ultimo momento utile per aggiungere qualcosa prima di
         confermare */
      azioni.insertAdjacentElement('afterend', box);
    }

    var scritto = box.querySelector('.cube-nota__campo');

    /* non si riscrive mentre ci stanno scrivendo dentro */
    leggiNota().then(function (v) {
      if (document.activeElement === scritto) return;
      if (scritto.value !== v) scritto.value = v;
      if (v) box.open = true;
    });
  }

  /* ---------- l'isola dati e' vecchia? ---------- */

  /* Vedi "L'ISOLA DATI INVECCHIA" in testa. Le due impronte sono lo
     stesso elenco - chiave di riga per quantita' - letto dalle due
     parti che devono coincidere. */

  var ultimaChiesta = null;
  var inCorso = false;
  var daRifare = false;

  function improntaIsola(payload) {
    if (!payload || !payload.lines) return '';
    return payload.lines.map(function (l) {
      return l.key + 'x' + l.quantity;
    }).join(',');
  }

  function improntaPagina() {
    var parti = [];
    document.querySelectorAll('cart-items-component [data-key]').forEach(function (el) {
      var q = el.querySelector('input[type="number"], input[name="updates[]"]');
      if (!q) return;
      parti.push(el.dataset.key + 'x' + q.value);
    });
    return parti.join(',');
  }

  /* Una modifica arrivata mentre la richiesta era in volo non va persa:
     si segna e si rifa' il giro appena la prima e' rientrata. Chi
     preme il piu' tre volte di fila fa partire una richiesta, non tre,
     e l'ultima parola resta all'ultimo clic. */
  function rileggi() {
    if (inCorso) {
      daRifare = true;
      return;
    }
    inCorso = true;
    daRifare = false;

    fetch(cartUrl(), { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresca = doc.getElementById('cube-preorder-data');
        var vecchia = document.getElementById('cube-preorder-data');
        if (fresca && vecchia) vecchia.textContent = fresca.textContent;
      })
      .catch(function () {})
      .then(function () {
        inCorso = false;
        /* ora i numeri buoni ci sono: si ridisegna */
        var payload = data();
        if (payload) {
          placeMeta(payload);
          placeSummary(payload);
        }
        if (daRifare) rileggi();
      });
  }

  function controlla(payload) {
    var pagina = improntaPagina();

    /* nessuna riga a schermo: non c'e' niente da confrontare - il
       carrello e' vuoto, oppure il cassetto non e' mai stato aperto */
    if (!pagina) return;
    if (pagina === improntaIsola(payload)) return;

    /* una sola richiesta per stato di pagina: vedi il commento in testa */
    if (pagina === ultimaChiesta) return;
    ultimaChiesta = pagina;

    rileggi();
  }

  function run() {
    placeButton();

    var payload = data();
    if (!payload) return;

    placeMeta(payload);
    placeSummary(payload);

    controlla(payload);
  }

  function init() {
    run();

    /* Il carrello e' cambiato per davvero: non si sta a confrontare le
       impronte, perche' l'evento puo' arrivare un istante prima che la
       pagina finisca di ridisegnarsi e a quel punto le due
       coinciderebbero ancora - restando indietro di una mossa. */
    document.addEventListener('cart:update', function () {
      ultimaChiesta = null;
      rileggi();
    });

    var root = document.querySelector('cart-items-component') || document.body;
    new MutationObserver(function () {
      requestAnimationFrame(run);
    }).observe(root, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
